const URL = "https://reports.tsdtools.com";

export default URL;
